module.exports = __webpack_public_path__ + "img/card-referrals-part-c-to-part-b-hover.a0a3da4f.svg";